const styles = theme => ({
  textFontSize: {
    fontSize: 13,
    marginLeft: 4,
  },
  textFontSizeHighlighted: {
    fontSize: 13,
    marginLeft: 4,
    color: 'rgba(52, 118, 203, 1.0)',
  },
  buttonHeight: {
    borderRadius: 5,
    borderHeight: 10,
    height: '100%',
    width:'86%',
    marginTop:-2.9,
    '&:hover': {
      background: 'rgba(243, 243, 243, 0.5)',
    },
  },
  iconFontSize: {
    width:20,
    height:20,
    marginLeft: 4,
  },
  iconFontSizeHighlighted: {
    width:20,
    height:20,
    marginLeft: 4,
    color: 'rgba(52, 118, 203, 1.0)',
  },
  height10: {
    paddingTop:10,
    paddingBottom:10,
  },
  linkRoute: {
    border: 'none',
    boxShadow: 'none',
    textDecoration: 'none',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/SideItems/components/Communication/styles.js